import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "../data/mock";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#061B2E] text-white relative">
      {/* Top accent line */}
      <div className="h-1 bg-gradient-to-r from-[#16C79A] via-[#16C79A] to-[#16C79A]" />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="Steamers"
              className="h-20 w-auto object-contain mb-6"
            />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Professional wheelie bin cleaning using eco-friendly
              hospital grade cleaning technology. Serving local communities with
              pride.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/70 mb-6">
              Quick Links
            </h4>
            <div className="space-y-3">
              {[
                { label: "Why Clean Your Bin?", href: "#reasons" },
                { label: "How It Works", href: "#how-it-works" },
                { label: "Sign Up", href: "#signup" },
              ].map((link) => (
                <button
                  key={link.label}
                  onClick={() => {
                    const el = document.querySelector(link.href);
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="block text-white/50 hover:text-[#16C79A] transition-colors duration-200 text-sm"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/70 mb-6">
              Get In Touch
            </h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0">
                  <Phone size={14} className="text-[#16C79A]" />
                </div>
                <a href="https://wa.me/971502856909" target="_blank" rel="noopener noreferrer" className="text-white/50 text-sm hover:text-[#16C79A] transition-colors">0502856909</a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0">
                  <Mail size={14} className="text-[#16C79A]" />
                </div>
                <a href="mailto:steamersdubai@gmail.com" className="text-white/50 text-sm hover:text-[#16C79A] transition-colors">
                  steamersdubai@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center flex-shrink-0">
                  <MapPin size={14} className="text-[#16C79A]" />
                </div>
                <span className="text-white/50 text-sm leading-relaxed">
                  Sarah Building, Al Garhoud,<br />
                  Plot 155-0, Dubai
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          {/* Business registration block */}
          <div className="text-center md:text-left mb-6">
            <p className="text-white/40 text-xs leading-relaxed">
              <span className="text-white/60 font-semibold">Steamers Building Cleaning Services LLC</span>
              <span className="hidden sm:inline">  ·  </span>
              <br className="sm:hidden" />
              Trade License: 1616564
              <span className="hidden sm:inline">  ·  </span>
              <br className="sm:hidden" />
              Sarah Building, Al Garhoud, Plot 155-0, Dubai
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-white/5">
            <p className="text-white/30 text-sm">
              &copy; {currentYear} Steamers. All rights reserved.
            </p>
            <div className="flex gap-6">
              <span className="text-white/30 text-sm hover:text-white/50 cursor-pointer transition-colors">
                Privacy Policy
              </span>
              <span className="text-white/30 text-sm hover:text-white/50 cursor-pointer transition-colors">
                Terms of Service
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
